import { render, staticRenderFns } from "./SearchBrowseTable.vue?vue&type=template&id=0713f7b5&scoped=true"
import script from "./SearchBrowseTable.vue?vue&type=script&lang=ts"
export * from "./SearchBrowseTable.vue?vue&type=script&lang=ts"
import style0 from "./SearchBrowseTable.vue?vue&type=style&index=0&id=0713f7b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0713f7b5",
  null
  
)

export default component.exports